// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-options-dropdown--sdkDr>.dropdown-toggle{display:flex;align-items:center}.user-options-dropdown--sdkDr>.dropdown-toggle:hover{background-color:rgba(0,0,0,0)}.user-options-dropdown--sdkDr>.dropdown-toggle>.avatar-wrapper{cursor:pointer;max-height:1.75rem;max-width:1.75rem}.user-options-dropdown--sdkDr .dropdown-menu{max-width:300px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-options-dropdown": "user-options-dropdown--sdkDr"
};
export default ___CSS_LOADER_EXPORT___;
